import { render, staticRenderFns } from "./site-link.vue?vue&type=template&id=72ed3f5a"
import script from "./site-link.vue?vue&type=script&lang=js"
export * from "./site-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports